import Main from '@/views/main.vue'

import {carMenuRouter} from './car'
import {cardetailMenuRouter} from './cardetail'

const recordMenuRouter = {
  has: 'vehicle',
  path: '/',
  icon: 'android-people',
  name: 'recordMenuRouter',
  title: '车辆档案',
  component: Main,
  children: [
    ...carMenuRouter
  ]
}

const recordOtherRouter = {
  path: '/',
  icon: 'android-people',
  name: 'recordOtherRouter',
  title: '车辆档案',
  component: Main,
  children: [
    ...cardetailMenuRouter
  ]
}

export {recordMenuRouter, recordOtherRouter}



// WEBPACK FOOTER //
// ./src/router/record/index.js